import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      productsToCompare: 'productCompare/productsToCompare',
      category: 'productCompare/categroy',
    }),

    processedCategory() {
      let result = this.category;
      
      const questionMarkIndex = result.indexOf('?');
      if (questionMarkIndex !== -1) {
        result = result.substring(0, questionMarkIndex);
      }
      
      if (result.endsWith('/')) {
        result = result.substring(0, result.length - 1);
      }
      
      return result;
    },

    moreProductsPath() {
      const processedCategory = this.category.includes('/') ? this.category.substring(0, this.category.indexOf("/")) : this.category;
      return this.localePath('/products/' + processedCategory);
    },

    allowCompareProducts() {
      return this.productsToCompare.length > 1;
    },
  },

  methods: {
    compareProducts() {
      if (!this.allowCompareProducts)
        return;

      const comparisonPath = this.createComparisonPath();
      this.$router.push(comparisonPath);
    },

    updateCompareProductsPath() {
      const comparisonPath = this.productsToCompare?.length > 0 ? this.createComparisonPath(true) : { path: this.moreProductsPath };
      this.$router.replace(comparisonPath);
    },

    createComparisonPath(inComparisonPage = false) {
      const dummyBaseURL = 'https://10life.com';
      const products = [];

      this.productsToCompare.forEach((product) => {
        const processedProduct = { kv: {} };
        const productURL = new URL(product.link, dummyBaseURL);
        const code = /[^/]*$/.exec(productURL.pathname)[0];
        processedProduct.code = code;
        for (const [key, value] of productURL.searchParams.entries()) {
          processedProduct.kv[key] = value;
        }
        products.push(processedProduct);
      });

      const comparisonPath = () => {
        let originalPath;
        if (this.processedCategory && !inComparisonPage)
          originalPath = '/products/' + this.processedCategory
        else
          originalPath = this.$route.path
        return this.$extendPath(originalPath, inComparisonPage ? '' : '/compare');
      }

      return {
        path: this.localePath(comparisonPath()),
        query: products.length > 0 ? { data: JSON.stringify(products) } : {},
      };

      // push below array as query params (example)
      // [{
      //   code: 'Bowtie_TermLife_1P1_Standard_NA_hkd_M35_1000000',
      //   kv: {
      //     age: '35',
      //     targetPeriod: '10',
      //     gender: '1',
      //   },
      // }]
    },

    removeProduct(id) {
      this.$store.commit('productCompare/removeProductToCompare', id);
    },

    removeProductAndReRenderPath(id) {
      this.$store.commit('productCompare/removeProductToCompare', id);
      if (this.$route.path.includes('dummy-product-comparison'))
        return;
      this.updateCompareProductsPath();
    },

    updateProductAndReRenderPath(targetPID, newP) {
      const params = {
        targetProductID: targetPID,
        newProduct: newP
      }
      this.$store.commit('productCompare/updateProductToCompare', params);

      if (this.$route.path.includes('dummy-product-comparison'))
        return;

      this.updateCompareProductsPath();
    },

    clearAllProducts() {
      this.$store.commit('productCompare/clearProducts');
    },
  }
}